import './ScenesHandler.scss';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AnalyticsContext } from '@/v2/components/application/Analytics';
import ProgressHandler from '@/v2/components/application/ProgressHandler';
import { IsMobile } from '@/v2/components/utils/DeviceUtils';
import SwipeForMobile from '@/v2/components/behaviours/SwipeForMobile';
import MomentNavigation from '@/v2/components/layouts/MomentNavigation';
import Loading from '@/v2/components/atoms/Loading';

const isMobile = IsMobile();

// eslint-disable-next-line  no-prototype-builtins, no-confusing-arrow
const isEnabled = (data) => (data.hasOwnProperty('enabled') && data.enabled != null ? data.enabled : true);

class ScenesHandler extends React.Component {
    constructor(props) {
        super(props);

        this.lastTrackingScene = null;
        this.updateHash = this.updateHash.bind(this);
        this.goToNext = this.goToNext.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);

        const { children } = this.props;
        let activeSceneIndex = 0;
        const scenes = children
            .filter((child) => isEnabled(child.props.data))
            .reduce((currentScenes, child, index) => {
                currentScenes.push({
                    path: child.props.path,
                });
                if (child.props.path === props.location.hash.slice(1)) activeSceneIndex = index;

                return currentScenes;
            }, []);

        const state = {
            activeSceneIndex,
            isLoading: true,
            scenes,
        };

        this.state = state;

        this.goToNext = this.goToNext.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
    }

    onFinished = (_index) => {
        const { onFinished } = this.props;
        const { scenes, activeSceneIndex } = this.state;

        this.setState({ isLoading: true });

        const currentSceneIndex = _index || activeSceneIndex;
        const nextSceneIndex = currentSceneIndex + 1;

        if (nextSceneIndex < scenes.length) {
            this.loadScene(nextSceneIndex);
        } else {
            onFinished();
        }
    };

    onReady = (index) => {
        const { scenes, activeSceneIndex } = this.state;
        const { onReady, location, history } = this.props;

        this.setState({ isLoading: false });

        if (!location.hash) history.replace(`#${scenes[activeSceneIndex].path}`);

        this.loadScene(index);

        if (onReady) onReady();
    };

    updateHash(direction) {
        const { location } = this.props;

        if (isMobile && location.hash.toLocaleLowerCase().indexOf('exterior') !== -1) return;

        const { activeSceneIndex, scenes } = this.state;

        if (direction > 0 && activeSceneIndex > 0) this.goToPrevious();

        if (direction < 0 && activeSceneIndex < scenes.length - 1) this.goToNext();
    }

    loadScene(index) {
        const { scenes } = this.state;
        const { history } = this.props;

        this.setState({ activeSceneIndex: index }, () => {
            if (scenes[index].path) history.replace(`#${scenes[index].path}`);
        });
    }

    goToNext() {
        this.onFinished();
    }

    goToPrevious() {
        const { history, location } = this.props;
        const { pathname } = location;
        const { activeSceneIndex } = this.state;

        this.setState({ isLoading: true });

        const previousSceneIndex = activeSceneIndex - 1;

        // go to previous scene if available, else re-route to navigation carousel
        if (previousSceneIndex >= 0) {
            this.loadScene(previousSceneIndex);
        } else {
            history.push(`/scenes.html#${pathname.slice(1, pathname.length - 5)}`);
        }
    }

    render() {
        const { isLoading, activeSceneIndex } = this.state;
        const { children } = this.props;

        const getVisibilityClassName = (isActive) => (isActive ? 'ScenesHandler__active' : 'ScenesHandler__hidden');

        return (
            <>
                <ProgressHandler>
                    {React.Children.toArray(children)
                        .filter((child) => isEnabled(child.props.data))
                        .map((child, index) =>
                            index === activeSceneIndex ? (
                                <>
                                    <div className={getVisibilityClassName(!isLoading)}>
                                        {React.cloneElement(child, {
                                            isActive: !isLoading,
                                            onReady: () => this.onReady(activeSceneIndex),
                                            onFinished: () => this.onFinished(activeSceneIndex),
                                        })}
                                    </div>
                                    {isLoading ? <Loading /> : null}
                                </>
                            ) : null
                        )}
                </ProgressHandler>
                {isMobile ? <SwipeForMobile update={this.updateHash} /> : <MomentNavigation nextAction={this.goToNext} previousAction={this.goToPrevious} />}
            </>
        );
    }
}

ScenesHandler.contextType = AnalyticsContext;

export default withRouter(ScenesHandler);
